(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      const ua = navigator.userAgent || '';
      const isiOS = /iP(hone|ad|od)/i.test(ua);
      this.isIosScrollStabilized = isiOS && (/CriOS/i.test(ua) || /Instagram/i.test(ua));
      if (this.isIosScrollStabilized) document.documentElement.classList.add('ios-scroll-stabilized');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      if (this.isIosScrollStabilized) this.headerIsAlwaysSticky = true;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        if (this.isIosScrollStabilized) this.header.classList.add('ios-chrome-sticky');
      };

      this.currentScrollTop = 0;
      this.lastViewportHeight = window.innerHeight;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.scrollThreshold = 10;
      this.lastHeaderState = 'reset';

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    getHeaderHeight() {
      return this.header.offsetHeight;
    }

    isNearBottom() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
      return (scrollTop + windowHeight) >= (documentHeight - 100);
    }

    onResize() {
      this.setHeaderHeight();
      this.lastViewportHeight = window.innerHeight;
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerHeight = this.getHeaderHeight();
      const scrollDelta = scrollTop - this.currentScrollTop;
      const viewportHeight = window.innerHeight;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.isIosScrollStabilized) {
        this.currentScrollTop = scrollTop;
        return;
      }

      // Ignore scroll changes while the mobile browser UI is resizing the viewport.
      if (Math.abs(viewportHeight - this.lastViewportHeight) > 1) {
        this.lastViewportHeight = viewportHeight;
        this.setHeaderHeight();
        this.currentScrollTop = scrollTop;
        return;
      }

      // Prevent state changes when near bottom of page (mobile viewport issues)
      if (this.isNearBottom()) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollDelta > this.scrollThreshold && scrollTop > headerHeight) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        if (this.lastHeaderState !== 'hidden') {
          this.lastHeaderState = 'hidden';
          requestAnimationFrame(this.hide.bind(this));
        }
        this.currentScrollTop = scrollTop;
      } else if (scrollDelta < -this.scrollThreshold && scrollTop > headerHeight) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          if (this.lastHeaderState !== 'revealed') {
            this.lastHeaderState = 'revealed';
            requestAnimationFrame(this.reveal.bind(this));
          }
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
        this.currentScrollTop = scrollTop;
      } else if (scrollTop <= 0) {
        this.header.classList.remove('scrolled-past-header');
        if (this.lastHeaderState !== 'reset') {
          this.lastHeaderState = 'reset';
          requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
